import { type ReactNode, useCallback } from 'react';

import { Images as ImagesIcon } from '@air/next-icons';
import { useToasts } from '@air/provider-toast';

export const useLibraryToasts = () => {
  const { showToast } = useToasts();

  const showLibraryToast = useCallback(
    ({ message, type = 'info' }: { message: ReactNode; type?: 'error' | 'info' }) => {
      showToast(message, {
        color: type === 'error' ? 'red' : 'black',
        prefix: <ImagesIcon className="size-4" />,
        withCloseButton: true,
      });
    },
    [showToast],
  );

  return { showLibraryToast };
};
